import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=aa52bf9e&scoped=true"
import script from "./tickets.vue?vue&type=script&lang=js"
export * from "./tickets.vue?vue&type=script&lang=js"
import style0 from "./tickets.vue?vue&type=style&index=0&id=aa52bf9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa52bf9e",
  null
  
)

export default component.exports